import { SVGIconProps } from '../types/svg';

export const Trophee = (props: SVGIconProps) => (
    <svg width="50" height="51" viewBox="0 0 50 51" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
        <path
            d="M17.1945 14.8425H32.8055V25.2329C32.8055 29.5438 29.3109 33.0384 25 33.0384V33.0384C20.6891 33.0384 17.1945 29.5438 17.1945 25.2329V14.8425Z"
            stroke="#00354F"
            strokeLinejoin="round"
        />
        <path d="M25 30.1958L25.0704 30.1958C28.0297 30.1958 30.4287 27.7968 30.4287 24.8375V24.8375" stroke="#FF8A02" strokeWidth="0.5" strokeLinejoin="round" />
        <path d="M12.2622 16.9038H17.1945V24.3086V24.3086C14.4705 24.3086 12.2622 22.1004 12.2622 19.3764V16.9038Z" stroke="#00354F" strokeLinejoin="round" />
        <path d="M37.7378 16.9038H32.8055V24.3086V24.3086C35.5295 24.3086 37.7378 22.1004 37.7378 19.3764V16.9038Z" stroke="#00354F" strokeLinejoin="round" />
        <path d="M25 33.0699V38.7643" stroke="#00354F" strokeLinejoin="round" />
        <path
            d="M16.2397 42.4606C16.2397 40.4368 17.8804 38.7961 19.9042 38.7961H30.0958C32.1196 38.7961 33.7602 40.4368 33.7602 42.4606V42.4606C33.7602 42.7135 33.5552 42.9186 33.3022 42.9186H16.6978C16.4448 42.9186 16.2397 42.7135 16.2397 42.4606V42.4606Z"
            stroke="#00354F"
            strokeLinejoin="round"
        />
        <path d="M25.2887 9.53603V5.30704" stroke="#FF8A02" strokeLinecap="round" />
        <path d="M18.8554 11.0839L16.6365 8.86498" stroke="#278BE5" strokeLinecap="round" />
        <path d="M31.6295 11.0839L33.8484 8.86499" stroke="#278BE5" strokeLinecap="round" />
    </svg>
);
